import React, { Component } from 'react';
import Select from 'react-select';
// import { Form } from 'react-bootstrap';
import api from 'helpers/api';
import {
  getIdUsuario,
  setIdEmpresa,
  setNomeEmpresa,
  getNomeEmpresa,
  getIdEmpresa,
  getEmailUsuario,
  setAccount,
  setNomeAccount,
  setEmailAccount,
  setTelefoneAccount,
  setRamalAccount,
  setUnidadeAccount,
  setFotoAccount,
  setComercial,
  setNomeComercial,
  setEmailComercial,
  setTelefoneComercial,
  setRamalComercial,
  setUnidadeComercial,
  setFotoComercial,
  setCNPJ
} from 'helpers/auth';

export default class Empresa extends Component {
  componentDidMount() {
    this.getOptions();
  }
  constructor(props) {
    super(props);
    this.state = {
      selectOptions: [],
      id: '',
      name: '',
      account: '',
      comercial: '',
      cnpj: ''
    };
  }

  async getOptions() {
    const res = await api.get('/api/empresas/' + getEmailUsuario());
    const data = res.data.result;
    if (data.length === 1) {
      setIdEmpresa(data[0].cod_emp);
      setNomeEmpresa(data[0].fantasia_emp + '(' + data[0].cgc_emp + ')');
      setCNPJ(data[0].cgc_emp);
      // this.setState({
      //   id: data[0].cod_emp,
      //   name: data[0].fantasia_emp + '(' + data[0].cgc_emp + ')',
      //   account: data[0].AccountId
      // });
    }
    const options = data.map(d => ({
      value: d.cod_emp,
      label: d.fantasia_emp + '(' + d.cgc_emp + ')',
      // account: d.AccountId,
      // comercial: d.PromotorID,
      cnpj: d.cgc_emp
    }));
    this.setState({ selectOptions: options });
    // window.location.reload();  
  }

  // async getAccount(codAccount) {
  //   setAccount('');
  //   setNomeAccount('');
  //   setEmailAccount('');
  //   setTelefoneAccount('');
  //   setRamalAccount('');
  //   setUnidadeAccount('');
  //   setFotoAccount('');
  //   const res = await api.get('/api/empresas/account/' + codAccount);
  //   const data = res.data.result;
  //   if (data.length > 0) {
  //     setAccount(data[0].acc_codExt);
  //     setNomeAccount(data[0].acc_nome);
  //     setEmailAccount(data[0].acc_email);
  //     setTelefoneAccount(data[0].acc_telefone);
  //     setRamalAccount(data[0].acc_ramal);
  //     setUnidadeAccount(data[0].acc_unidade);
  //     setFotoAccount(data[0].acc_url_foto);
  //   } else {
  //     setAccount('');
  //     setNomeAccount('');
  //     setEmailAccount('');
  //     setTelefoneAccount('');
  //     setRamalAccount('');
  //     setUnidadeAccount('');
  //     setFotoAccount('');
  //   }
  //   //
  // }

  // async getComercial(codComercial) {
  //   const res = await api.get('/api/empresas/comercial/' + codComercial);
  //   const data = res.data.result;
  //   if (data.length > 0) {
  //     setComercial(data[0].cmo_codExt);
  //     setNomeComercial(data[0].cmo_nome);
  //     setEmailComercial(data[0].cmo_email);
  //     setTelefoneComercial(data[0].cmo_telefone);
  //     setRamalComercial(data[0].cmo_ramal);
  //     setUnidadeComercial(data[0].cmo_unidade);
  //     setFotoComercial(data[0].cmo_url_foto);
  //   } else {
  //     setComercial('');
  //     setNomeComercial('');
  //     setEmailComercial('');
  //     setTelefoneComercial('');
  //     setRamalComercial('');
  //     setUnidadeComercial('');
  //     setFotoComercial('');
  //   }
  //   window.location.reload();
  // }

  handleSelectCity = option => {
    this.setState({
      id: option.value,
      name: option.label,
      account: option.AccountId
    });
    setIdEmpresa(option.value);
    setNomeEmpresa(option.label);
    setCNPJ(option.cnpj);
    window.location.reload();  
    // this.getAccount(option.account);
    // this.getComercial(option.PromotorID);
  };

  render() {
    const { selectOptions } = this.state;
    return (
      <Select
        // style={{ width: '25rem' }}
        className="text-nowrap"
        value={getIdEmpresa()}
        autoFocus={true}
        style={{width: '28rem', color: 'blue',}}
        options={selectOptions}
        placeholder={
          // getNomeEmpresa()
          getNomeEmpresa() === '' ? 'Selecione a Empresa' : getNomeEmpresa()
        }
        onChange={this.handleSelectCity}
      />
    );
  }
}
